import React from 'react';
import PropTypes from 'prop-types';
import styles from './CardSlider.module.scss';
import ArrowBackIosRoundedIcon from '@material-ui/icons/ArrowBackIosRounded';
import classNames from 'classnames';
import { useTranslation } from '../../../i18n/LanguageProvider';

const CardSlider = (props) => {
  const { t } = useTranslation();
  return (
    <div {...props} className={styles.slider}>
      <div className={classNames(styles.container, props.extraClass)}>
        {props.children}
        {props.more && (
          <div className={styles.more} onClick={props.handleClick}>
            <div className={styles.icon}>
              <ArrowBackIosRoundedIcon className="flip-ltr" />
            </div>
            {t('common.all')}
          </div>
        )}
      </div>
    </div>
  );
};

CardSlider.propTypes = {
  id: PropTypes.string,
  more: PropTypes.bool,
  handleClick: PropTypes.func,
  extraClass: PropTypes.string,
  children: PropTypes.node
};

export default CardSlider;
